var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEditprofil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6842",
    "data-name": "Group 6842",
    transform: "translate(-314 -92)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1219",
    "data-name": "Ellipse 1219",
    transform: "translate(316 94)",
    fill: "#000002",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 21,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "write",
    transform: "translate(319.565 94.98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6829",
    "data-name": "Group 6829",
    transform: "translate(22.385 25.846)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15112",
    "data-name": "Path 15112",
    d: "M44.862,54.587a.862.862,0,1,1,0-1.725h0a.862.862,0,1,1,1.724,0A1.727,1.727,0,0,1,44.862,54.587Z",
    transform: "translate(-44 -52)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6830",
    "data-name": "Group 6830",
    transform: "translate(23.248 17.388)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15113",
    "data-name": "Path 15113",
    d: "M46.862,42.568A.863.863,0,0,1,46,41.705V33.247a.862.862,0,1,1,1.725,0v8.458A.863.863,0,0,1,46.862,42.568Z",
    transform: "translate(-46 -32.385)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6831",
    "data-name": "Group 6831",
    transform: "translate(6.862 26.708)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15114",
    "data-name": "Path 15114",
    d: "M24.385,55.725H8.862a.862.862,0,0,1,0-1.725H24.385a.862.862,0,1,1,0,1.725Z",
    transform: "translate(-8 -54)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6832",
    "data-name": "Group 6832",
    transform: "translate(6 25.846)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15115",
    "data-name": "Path 15115",
    d: "M7.725,54.587A1.727,1.727,0,0,1,6,52.862a.862.862,0,1,1,1.725,0h0a.862.862,0,1,1,0,1.723Z",
    transform: "translate(-6 -52)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6833",
    "data-name": "Group 6833",
    transform: "translate(6 10.323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15116",
    "data-name": "Path 15116",
    d: "M6.862,33.248A.863.863,0,0,1,6,32.385V16.862a.862.862,0,0,1,1.725,0V32.385A.863.863,0,0,1,6.862,33.248Z",
    transform: "translate(-6 -16)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6834",
    "data-name": "Group 6834",
    transform: "translate(6 9.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15117",
    "data-name": "Path 15117",
    d: "M6.862,16.587A.862.862,0,0,1,6,15.725,1.727,1.727,0,0,1,7.725,14a.862.862,0,1,1,0,1.725h0A.862.862,0,0,1,6.862,16.587Z",
    transform: "translate(-6 -14)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6835",
    "data-name": "Group 6835",
    transform: "translate(6.862 9.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15118",
    "data-name": "Path 15118",
    d: "M17.32,15.725H8.862a.862.862,0,0,1,0-1.725H17.32a.862.862,0,1,1,0,1.725Z",
    transform: "translate(-8 -14)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6836",
    "data-name": "Group 6836",
    transform: "translate(14.594 6.643)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15119",
    "data-name": "Path 15119",
    d: "M26.794,17.612a.862.862,0,0,1-.61-1.472l8.423-8.423a.862.862,0,0,1,1.219,1.219L27.4,17.36A.859.859,0,0,1,26.794,17.612Z",
    transform: "translate(-25.931 -7.465)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6837",
    "data-name": "Group 6837",
    transform: "translate(13.761 15.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15120",
    "data-name": "Path 15120",
    d: "M24.863,32.6a.844.844,0,0,1-.182-.019.862.862,0,0,1-.662-1.024l.833-3.882a.862.862,0,0,1,1.686.361l-.833,3.882A.863.863,0,0,1,24.863,32.6Z",
    transform: "translate(-24 -26.997)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6838",
    "data-name": "Group 6838",
    transform: "translate(17.643 9.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15121",
    "data-name": "Path 15121",
    d: "M33.865,24.682a.862.862,0,0,1-.61-1.472l8.423-8.422A.862.862,0,0,1,42.9,16.007L34.474,24.43A.858.858,0,0,1,33.865,24.682Z",
    transform: "translate(-33.002 -14.535)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6839",
    "data-name": "Group 6839",
    transform: "translate(13.761 18.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15122",
    "data-name": "Path 15122",
    d: "M24.861,36.626a.862.862,0,0,1-.18-1.705l3.882-.833a.862.862,0,1,1,.362,1.686l-3.882.833A.873.873,0,0,1,24.861,36.626Z",
    transform: "translate(-23.999 -34.069)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6840",
    "data-name": "Group 6840",
    transform: "translate(21.492 8.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15123",
    "data-name": "Path 15123",
    d: "M45.84,15.774a.858.858,0,0,1-.61-.253l-3.049-3.049A.862.862,0,0,1,43.4,11.253L46.45,14.3a.862.862,0,0,1-.61,1.472Z",
    transform: "translate(-41.929 -11)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6841",
    "data-name": "Group 6841",
    transform: "translate(23.016 6.019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15124",
    "data-name": "Path 15124",
    d: "M49.374,11.416a.863.863,0,0,1-.61-1.473,1.313,1.313,0,0,0,0-1.828,1.345,1.345,0,0,0-1.83,0A.862.862,0,1,1,45.715,6.9a3.018,3.018,0,0,1,4.268,4.268.856.856,0,0,1-.609.252Z",
    transform: "translate(-45.462 -6.019)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditprofil);
export default __webpack_public_path__ + "static/media/icon-editprofil.74463167.svg";
export { ForwardRef as ReactComponent };